import { ChevronRight } from "lucide-react";
import { cn } from "../lib/utils";
import { useNavigate, useLocation } from "react-router-dom";

const websiteTabs = [
  {
    id: "template-section",
    label: "Template Section",
    path: "/website/templatesection",
  },
  {
    id: "section-settings",
    label: "Section Settings",
    path: "/website/storesetting",
  },
  { id: "front-theme", label: "Front Theme", path: "/website/fronttheme" },
  { id: "hero-section", label: "Hero Section", path: "/website/herosection" },
  {
    id: "about-section",
    label: "About Section",
    path: "/website/aboutsection",
  },
  {
    id: "testimonials-section",
    label: "Testimonials Section",
    path: "/website/testimonialsection",
  },
  {
    id: "gallery-section",
    label: "Gallery Section",
    path: "/website/gallerysection",
  },
  {
    id: "footer-settings",
    label: "Footer Settings",
    path: "/website/footersection",
  },
  { id: "about-us-page", label: "About Us Page", path: "/website/aboutuspage" },
];

export default function WebsiteSubSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="relative w-full lg:w-56 lg:ml-2 lg:mt-3">
      <div className="flex flex-row lg:flex-col overflow-x-auto lg:overflow-y-auto w-full bg-white py-2 lg:py-4 border-b lg:border-none scrollbar-hide relative">
        {websiteTabs.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={cn(
                "relative flex items-center px-4 py-2 text-[14px] lg:text-[15px] font-medium text-left transition-all duration-200 group whitespace-nowrap",
                isActive
                  ? "text-purple-600"
                  : "text-gray-800 hover:text-purple-600"
              )}
            >
              <ChevronRight
                className={cn(
                  "absolute left-0 w-4 h-4 opacity-0 transform transition-all duration-200 hidden lg:block",
                  isActive
                    ? "opacity-100 text-purple-600 translate-x-0"
                    : "group-hover:opacity-100 group-hover:text-purple-600 group-hover:translate-x-0"
                )}
              />
              <span
                className={cn(
                  "transition-all duration-200",
                  isActive ? "lg:translate-x-4" : "lg:group-hover:translate-x-4",
                  isActive && "border-b-2 border-purple-600 lg:border-none pb-1 lg:pb-0"
                )}
              >
                {item.label}
              </span>
            </button>
          );
        })}
        {/* Right side fade for mobile scroll */}
        <div className="lg:hidden absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </div>
  );
}
